import Vue from 'vue';
import App from './App.vue';
import router from './router';

import './assets/css/main.scss';
import '@mdi/font/css/materialdesignicons.min.css';

Vue.config.productionTip = false;

//ELEMENT
import element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/es'
Vue.use(element, {locale});

//MOMENT
const moment = require('moment')
require('moment/locale/es')
Vue.use(require('vue-moment'), {moment});

//PARA INFINITE SCROLL
import VueObserveVisibility from 'vue-observe-visibility'
Vue.use(VueObserveVisibility)

//VCALENDAR
import VCalendar from 'v-calendar';
Vue.use(VCalendar,{
    firstDayOfWeek: 2
});

//VUE HIGHCHART
import VueHighcharts from 'vue-highcharts';
import Highcharts from 'highcharts';
import highchartsMore from 'highcharts/highcharts-more'
import solidGauge from 'highcharts/modules/solid-gauge';
import wordcloud from 'highcharts/modules/wordcloud';

const   colors = ['white','green','red']

Highcharts.setOptions({
    colors: colors,
    lang: {
        months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        shortMonths: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
        weekdays: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
        thousandsSep: '.'
    }
});
highchartsMore(Highcharts);
solidGauge(Highcharts);
wordcloud(Highcharts);
Vue.use(VueHighcharts);

//SWIPER
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper);

//VUE SCROLL
import vuescroll from 'vuescroll'
Vue.use(vuescroll)



Vue.filter('reduceBigNumbers', function(number, decimals) {
    return reduceBigNumbers(number, decimals)
});
Vue.filter('numberFormat', function(number, decimals) {
    return numberFormat(number, decimals)
});

export function reduceBigNumbers(number, decimals=2) {
    if (number > 1000000 || number < -1000000) {
        return numberFormat(number / 1000000, decimals) + 'M';
    }

    if (number > 1000 || number < -1000) {
        return numberFormat(number / 1000, decimals) + 'K';
    }

    return numberFormat(number, decimals);
}

export function numberFormat(number, decimals) {

    if(typeof number == 'number'){

        decimals = (decimals != undefined) ?  decimals : 2
        return parseFloat(number).toLocaleString('en', {
            maximumFractionDigits: decimals,
            minimumFractionDigits: decimals
        }).replace(/,/g, '@').replace('.', ',').replace(/@/g, '.');
        // return parseFloat(number.toFixed(parseFloat(decimals))).toLocaleString('es-ES');
    }

}


new Vue({
    router,
    render: h => h(App)
}).$mount('#app')